export enum GeoJsonTypesEnum {
  POINT = 'Point',
  POLYGON = 'Polygon',
  MULTIPOLYGON = 'MultiPolygon',
  ST_MULTIPOLYGON = 'st_multipolygon',
  ST_POLYGON = 'st_polygon',
  ST_POINT = 'st_point',
  ST_GEOMETRY_COLLECTION = 'st_geometrycollection',
  ST_MULTIPOINT = 'st_multipoint',
  INVALID_GEOMETRY = 'invalid geometry',
  UNMAPPED = 'unmapped',
  OTHERS = 'others'
}
